export const getNavigationHistory = state => state.navigationHistory;
